import { render, staticRenderFns } from "./Lgx328506497581449216.vue?vue&type=template&id=55d8c480&"
import script from "./Lgx328506497581449216.vue?vue&type=script&lang=js&"
export * from "./Lgx328506497581449216.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports